import React from "react";
import TopBar from "../components/TopBar";

const Library = ()=>{
    return(<>
    <TopBar title={'Library'}/>
    </>)
}
export default Library;